import { createComponent } from '@mtfe/sweet';
import { common, dom } from '@mtfe/sweet-utils';
import tpl from './dom.html';
import style from './style.less';
import componentUtils from '../utils/index';

const { Describe } = componentUtils;
const COMPONENT_ID = 'waimai_ilf7s3pi';
const describeTopPoiB = new Describe('TopPoiB', COMPONENT_ID);

const { createUniqueId } = common;
const domId = createUniqueId();

const renderTopPoiB = (props) => {
    const component = TopPoiB({ ...props });
    dom.$id(domId).outerHTML = component;
};

const TopPoiB = (props) => {
    const { poiInfo, title, onPoiInfoClick, onSkuClick } = props;
    const poiLabel = poiInfo.poiBaseInfo.poi_label_map;
    let poiShowTags = [];
    if (poiLabel && poiLabel['1'] && poiLabel['1'].length) {
        poiShowTags = poiLabel['1'].slice(0, 3);
    }
    let skuInfoList = [];
    if (poiInfo.skuInfoList && poiInfo.skuInfoList.length) {
        skuInfoList = poiInfo.skuInfoList.slice(0, 3);
    }
    const data = {
        domId,
        title,
        poiInfo,
        poiShowTags,
        skuInfoList,
    };
    const events = {
        onPoiClick: () => {
            if (onPoiInfoClick) {
                onPoiInfoClick(poiInfo);
            }
        },
        onSkuGoodsClick: (e, index) => {
            if (onSkuClick) {
                onSkuClick(poiInfo, skuInfoList[index]);
                e.cancelBubble = true;
                e.stopPropagation();
                return false;
            }
        }
    };
    const component = createComponent(tpl, { data, style }, events);

    return component;
};

TopPoiB.describe = describeTopPoiB;
export default TopPoiB;
export { renderTopPoiB };
